
import request from '@/utils/request'

export function classAdd(data) {
  return request({
    url: 'grades/add',
    method: 'post',
    data
  })
}

export function classPaging(params) {
  return request({
    url: 'grades/paging',
    method: 'get',
    params
  })
}

export function classDel(id) {
  return request({
    url: '/grades/delete//' + id,
    method: 'delete'
  })
}

export function classUpdate(id, data) {
  return request({
    url: 'grades/update/' + id,
    method: 'put',
    data
  })
}

export function fetchClasses() {
  return request({
    url: 'grades/list',
    method: 'get'
  })
}

// 查看班级学生名单
export function fetchClass(classId) {
  return request({
    url: 'grades/show/' + classId,
    method: 'get'
  })
}

export function userClassRemove(ids) {
  return request({
    url: 'grades/remove/' + ids,
    method: 'patch'
  })
}
// 老师加入班级
export function teacherJoinClass(params) {
  return request({
    url: 'grades/teacher/join',
    method: 'get',
    params
  })
}
// 老师退出班级
export function teacherExitClass(gradeId) {
  return request({
    url: `grades/teacher/exit/${gradeId}`,
    method: 'delete'
  })
}

// 添加学生到班级
export function addStudentToClass(gradeId, username) {
  return request({
    url: `grades/${gradeId}/add-student`,
    method: 'post',
    params: { username }
  })
}

// 获取未加入班级的学生列表
export function getUnassignedStudents() {
  return request({
    url: 'grades/unassigned-students',
    method: 'get'
  })
}

// 根据学校+学号添加学生到班级
export function addStudentToClassBySchool(gradeId, studentNum, schoolName) {
  return request({
    url: `grades/${gradeId}/add-student-by-school`,
    method: 'post',
    params: { studentNum, schoolName }
  })
}

// 获取所有学校列表
export function getAllSchoolNames() {
  return request({
    url: 'grades/schools',
    method: 'get'
  })
}

// 批量导入学生名单
export function importStudentList(importData) {
  return request({
    url: 'grades/import-students',
    method: 'post',
    data: importData
  })
}

// 删除学生班级注册记录
export function removeStudentFromClass(classId, studentId) {
  return request({
    url: `grades/${classId}/student/${studentId}`,
    method: 'delete'
  })
}

// 更新学生信息
export function updateStudentInfo(studentId, studentData) {
  return request({
    url: `grades/student/${studentId}`,
    method: 'put',
    data: studentData
  })
}
